<template>
  <div>    
    <div class="form-group">
       <multiselect 
        v-model="valorPorDefecto"         
        :options="FundamentosLegales"
        select-label=""           
        :show-labels="false"
        :placeholder="placeholder"
        @select="cambioFundamentoLegal"
        label="Nombre"
      >
        <span slot="noResult">Sin coincidencias</span>
      </multiselect>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Multiselect from 'vue-multiselect'  

  export default {
    components:{Multiselect},
    data() {
      return {
        enumeraciones,
        comun,
        FundamentosLegales: [],
        idDelModelo: null,
        desHabilitaEdicion:true,
        valorPorDefecto: null        
      }
    },
    props: {
      
      // EL PLACEHOLDER SIRVE PARA CARGAR EL TEXTO QUE SE VA A MOSTRAR EN EL COMPONENTE, SI NO
      // SE LE CARGA UN VALOR DESDE EL PRINCIPIO, SE MOSTRARÁ EL VALOR QUE VIENE POR DEFECTO EN INGLÉS
      placeholder: String, 

      prefijo: Number,
      
      tipo: {
        Id: Number,
        Nombre: String
      },
      
      idDelInput: String,
      valorDefinido: Number,
      parametros: {AreaId:null,DepartamentoId:null},
    },
    created() {      
      //this.desHabilitaEdicion = this.hereda != null && this.hereda == -1
      this.cargaCatalogoDeFundamentosLegales()
    }, 
    mounted() {
      // if(this.valorDefinido == undefined || this.valorDefinido == null)
      //   this.idDelModelo = this.tipo.Id;
      // elsen
      //   this.idDelModelo = this.valorDefinido; 
      
      // const parametros = {
      //   llave: this.idDelInput,
      //   valor: this.idDelModelo
      // }
      //this.$store.dispatch("A_PJ_Catalogo_Establecer045Puesto", parametros);
    },
    methods: {
      
      cambioFundamentoLegal (evento) {
        this.$emit("valorParaElPadre", evento);
      },
      cargaCatalogoDeFundamentosLegales: function() {
        let peticion = {                      
          conInactivos: false,          
          EsPrueba: this.enumeraciones.EsPrueba,
        }
        axios.post(
          api.conexion + api.SIAP.catalogos.C036FundamentosLegales
          , peticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else { 
              this.vaciarFundamentosLegalesAlArreglo(respuesta.data.FundamentosLegales);                           
              return respuesta.data.Puestos;
            }
          }).catch(e => {
           console.log("No Hay Respuesta del Servidor" + e);
         });
      },
      vaciarFundamentosLegalesAlArreglo(fundamentosLegales){            
        let arregloDeFundamentosLegales = [];
        fundamentosLegales.forEach(fundamentoLegal => {   
          let fundamentoLegalInstancia = {};
          fundamentoLegalInstancia.FundamentoLegalId = fundamentoLegal.FundamentoLegalId; 
          fundamentoLegalInstancia.Nombre = fundamentoLegal.Nombre;       
          arregloDeFundamentosLegales.push(fundamentoLegalInstancia);
        });
        this.FundamentosLegales = arregloDeFundamentosLegales;        
      },
      cambiarDatos(evento) { 
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_PJ_Catalogo_Establecer045Puesto", parametros);
        this.$emit("valorParaElPadre", evento);
        
      }      
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__option--highlight {
  background: #504f54;
}

.multiselect__option--selected.multiselect__option--highlight{
  background: #007bff;
}
</style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/036FundamentosLegalesBuscador.vue